import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import 'styled-components';
import '../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../theme/ThemedComponentWrapper.js';
import '../icons/ActivityIcon.js';
import '../icons/ArrowDownIcon.js';
import '../icons/ArrowDownRightCircleIcon.js';
import '../icons/ArrowLeftAlignIcon.js';
import '../icons/ArrowLeftIcon.js';
import '../icons/ArrowRightAlignIcon.js';
import '../icons/ArrowRightIcon.js';
import '../icons/ArrowSwitchIcon.js';
import '../icons/ArrowUpIcon.js';
import '../icons/ArrowUpRightCircleIcon.js';
import '../icons/ArrowsAngleExpandIcon.js';
import '../icons/BankIcon.js';
import BlankNotepadIcon from '../icons/BlankNotepadIcon.js';
import '../icons/CheckIcon.js';
import '../icons/ChevronDownIcon.js';
import '../icons/ChevronRightIcon.js';
import '../icons/ChevronUpIcon.js';
import '../icons/CopyIcon.js';
import '../icons/CrossIcon.js';
import '../icons/DaiIcon.js';
import '../icons/DangerIcon.js';
import '../icons/DownSortIcon.js';
import '../icons/ExclamationTriangleIcon.js';
import '../icons/ExpandKpiIcon.js';
import '../icons/EyeIcon.js';
import '../icons/EyeSlashIcon.js';
import '../icons/Grid1x2Icon.js';
import '../icons/InfoCircleIcon.js';
import '../icons/ListIcon.js';
import '../icons/LockIcon.js';
import '../icons/MediumIcon.js';
import '../icons/MoonIcon.js';
import '../icons/PiggyBankIcon.js';
import '../icons/QuestionMarkCircleIcon.js';
import '../icons/ShieldIcon.js';
import '../icons/SunIcon.js';
import '../icons/UpSortIcon.js';
import '../icons/XIcon.js';
import '../atoms/Input/Input.js';
import '../atoms/ToggleSwitch.js';
import '../atoms/Table/Table.js';
import '../atoms/Table/components/HeaderCell/HeaderCell.js';
import Text from '../atoms/Text.js';
import 'luxon';
import '@floating-ui/react';
import '../atoms/Tooltip/components/TooltipContext.js';
import '../atoms/Tooltip/components/TooltipContent.js';
import '../atoms/Tooltip/components/TooltipTrigger.js';
import '../atoms/Table/components/Pagination/Pagination.js';
import '../atoms/layout/Stack/Stack.js';
import './CurrencyValue/components/Value.js';
import '../pictograms/EthPictogram.js';
import '../pictograms/EtherScanPictogram.js';
import '../pictograms/DebankPictogram.js';
import '../pictograms/ZapperPictogram.js';
import '../pictograms/DaiPictogram.js';
import './TrendValue.js';
import './KpiCard/KpiCard.js';
import './Tabs/Tabs.js';
import '../charts/ChartKpis/ChartKpi.js';
import '../charts/ChartJS.js';
import '../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../XRay.js';
import 'ethereum-blockies-base64';

function EmptyBox({ message = 'NO DATA', icon = null, ...rest }) {
    if (!icon) {
        icon = jsx(BlankNotepadIcon, {});
    }
    return (jsxs(ThemedComponentWrapper, { ...rest, name: "emptyBox", children: [icon ? icon : null, jsx(Text, { as: "p", variant: 'emptyBoxMessage', children: message })] }));
}

export { EmptyBox as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW1wdHlCb3guanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9FbXB0eUJveC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgVGV4dCB9IGZyb20gJ0BhdG9tcyc7XG5pbXBvcnQgeyBCbGFua05vdGVwYWRJY29uIH0gZnJvbSAnQGljb25zJztcbmltcG9ydCB7IFRoZW1lZENvbXBvbmVudFdyYXBwZXJQcm9wcyB9IGZyb20gJy4uLy4uL3RoZW1lL1RoZW1lZENvbXBvbmVudFdyYXBwZXInO1xuaW1wb3J0IHsgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgVGhlbWVkQ29tcG9uZW50V3JhcHBlciB9IGZyb20gJ0B0aGVtZSc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgRW1wdHlCb3hQcm9wcyBleHRlbmRzIFBhcnRpYWw8VGhlbWVkQ29tcG9uZW50V3JhcHBlclByb3BzPiB7XG4gIG1lc3NhZ2U/OiBzdHJpbmc7XG4gIGljb24/OiBSZWFjdE5vZGU7XG59XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIEVtcHR5Qm94KHtcbiAgbWVzc2FnZSA9ICdOTyBEQVRBJyxcbiAgaWNvbiA9IG51bGwsXG4gIC4uLnJlc3Rcbn06IEVtcHR5Qm94UHJvcHMpIHtcbiAgaWYgKCFpY29uKSB7XG4gICAgaWNvbiA9IDxCbGFua05vdGVwYWRJY29uIC8+O1xuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8VGhlbWVkQ29tcG9uZW50V3JhcHBlciB7Li4ucmVzdH0gbmFtZT1cImVtcHR5Qm94XCI+XG4gICAgICB7aWNvbiA/IGljb24gOiBudWxsfVxuXG4gICAgICA8VGV4dCBhcz1cInBcIiB2YXJpYW50PXsnZW1wdHlCb3hNZXNzYWdlJ30+XG4gICAgICAgIHttZXNzYWdlfVxuICAgICAgPC9UZXh0PlxuICAgIDwvVGhlbWVkQ29tcG9uZW50V3JhcHBlcj5cbiAgKTtcbn1cbiJdLCJuYW1lcyI6WyJfanN4IiwiX2pzeHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBV2MsU0FBVSxRQUFRLENBQUMsRUFDL0IsT0FBTyxHQUFHLFNBQVMsRUFDbkIsSUFBSSxHQUFHLElBQUksRUFDWCxHQUFHLElBQUksRUFDTyxFQUFBO0lBQ2QsSUFBSSxDQUFDLElBQUksRUFBRTtBQUNULFFBQUEsSUFBSSxHQUFHQSxHQUFBLENBQUMsZ0JBQWdCLEVBQUEsRUFBQSxDQUFHLENBQUM7S0FDN0I7QUFFRCxJQUFBLFFBQ0VDLElBQUEsQ0FBQyxzQkFBc0IsRUFBQSxFQUFBLEdBQUssSUFBSSxFQUFFLElBQUksRUFBQyxVQUFVLGFBQzlDLElBQUksR0FBRyxJQUFJLEdBQUcsSUFBSSxFQUVuQkQsR0FBQyxDQUFBLElBQUksRUFBQyxFQUFBLEVBQUUsRUFBQyxHQUFHLEVBQUMsT0FBTyxFQUFFLGlCQUFpQixFQUNwQyxRQUFBLEVBQUEsT0FBTyxFQUNILENBQUEsQ0FBQSxFQUFBLENBQ2dCLEVBQ3pCO0FBQ0o7Ozs7In0=
